export const translations = {
  fr: {
    // Welcome page
    welcome: {
      title: "Bienvenue",
      subtitle: "Mini-test comportemental",
      greeting: "Bonjour",
      description: "Vous avez été invité(e) à participer à un mini-test comportemental. Ce questionnaire nous aidera à vous mettre en relation avec le membre idéal pour vous accueillir à la réunion APOLLO.",
      duration: "Durée estimée : ~10 minutes",
      continue: "Continuer",
      start_button: "Commencer le test",
      already_completed: "Vous avez déjà complété ce test.",
      loading: "Chargement...",
      error: "Une erreur est survenue. Veuillez réessayer.",
      invalid_link: "Lien invalide. Veuillez vérifier votre invitation.",
      step_2: "Étape 2",
      sphere_title: "Votre sphère d'activité",
      sphere_description: "Sélectionnez le domaine qui correspond le mieux à votre activité professionnelle."
    },
    // Test page
    test: {
      question: "Question",
      of: "sur",
      progress: "Progression",
      scale: {
        1: "Pas du tout d'accord",
        2: "Pas d'accord",
        3: "Neutre",
        4: "D'accord",
        5: "Tout à fait d'accord"
      },
      previous: "Précédent",
      next: "Suivant",
      submit: "Terminer le test"
    },
    // Complete page
    complete: {
      title: "Merci !",
      subtitle: "Votre test est terminé",
      message: "Votre profil nous aidera à vous mettre en relation avec le membre idéal pour vous accueillir à la réunion. Et vous découvrirez les résultats de votre test.",
      footer: "Nous nous réjouissons de vous rencontrer lors de notre réunion."
    },
    // Admin
    admin: {
      login: {
        title: "Administration",
        subtitle: "Connexion sécurisée",
        email: "Email",
        password: "Mot de passe",
        submit: "Se connecter",
        error: "Identifiants incorrects"
      },
      dashboard: {
        title: "Tableau de bord",
        guests: "Invités",
        total: "Total",
        completed: "Complétés",
        pending: "En attente",
        search: "Rechercher un invité...",
        name: "Nom",
        status: "Statut",
        date: "Date",
        actions: "Actions",
        view_results: "Voir les résultats",
        no_guests: "Aucun invité trouvé",
        logout: "Déconnexion",
        disc_profile: "Profil DISC",
        values_profile: "Top 3 Valeurs"
      },
      viewers: {
        title: "Admins restreints",
        add: "Ajouter un admin",
        name: "Nom",
        email: "Email",
        password: "Mot de passe",
        groups: "Groupes",
        all_groups: "Tous les groupes",
        save: "Enregistrer",
        cancel: "Annuler",
        edit: "Modifier",
        delete: "Supprimer",
        no_viewers: "Aucun admin restreint",
        confirm_delete: "Êtes-vous sûr de vouloir supprimer cet admin ?"
      }
    },
    // Common
    common: {
      apollo: "APOLLO",
      guest: "GUEST"
    }
  },
  en: {
    // Welcome page
    welcome: {
      title: "Welcome",
      subtitle: "Behavioral mini-test",
      greeting: "Hello",
      description: "You have been invited to participate in a behavioral mini-test. This questionnaire will help us connect you with the ideal member to welcome you at the APOLLO meeting.",
      duration: "Estimated duration: ~10 minutes",
      continue: "Continue",
      start_button: "Start the test",
      already_completed: "You have already completed this test.",
      loading: "Loading...",
      error: "An error occurred. Please try again.",
      invalid_link: "Invalid link. Please check your invitation.",
      step_2: "Step 2",
      sphere_title: "Your activity sphere",
      sphere_description: "Select the domain that best matches your professional activity."
    },
    // Test page
    test: {
      question: "Question",
      of: "of",
      progress: "Progress",
      scale: {
        1: "Strongly disagree",
        2: "Disagree",
        3: "Neutral",
        4: "Agree",
        5: "Strongly agree"
      },
      previous: "Previous",
      next: "Next",
      submit: "Complete test"
    },
    // Complete page
    complete: {
      title: "Thank you!",
      subtitle: "Your test is complete",
      message: "Your profile will help us connect you with the ideal member to welcome you at the meeting. And you will discover the results of your test.",
      footer: "We look forward to meeting you at our meeting."
    },
    // Admin
    admin: {
      login: {
        title: "Administration",
        subtitle: "Secure login",
        email: "Email",
        password: "Password",
        submit: "Sign in",
        error: "Invalid credentials"
      },
      dashboard: {
        title: "Dashboard",
        guests: "Guests",
        total: "Total",
        completed: "Completed",
        pending: "Pending",
        search: "Search for a guest...",
        name: "Name",
        status: "Status",
        date: "Date",
        actions: "Actions",
        view_results: "View results",
        no_guests: "No guests found",
        logout: "Logout",
        disc_profile: "DISC Profile",
        values_profile: "Top 3 Values"
      },
      viewers: {
        title: "Restricted Admins",
        add: "Add admin",
        name: "Name",
        email: "Email",
        password: "Password",
        groups: "Groups",
        all_groups: "All groups",
        save: "Save",
        cancel: "Cancel",
        edit: "Edit",
        delete: "Delete",
        no_viewers: "No restricted admin",
        confirm_delete: "Are you sure you want to delete this admin?"
      }
    },
    // Common
    common: {
      apollo: "APOLLO",
      guest: "GUEST"
    }
  }
};

// Question translations
export const questionTranslations = {
  disc_1: { fr: "Je prends naturellement les décisions rapidement.", en: "I naturally make decisions quickly." },
  disc_2: { fr: "J'aime relever des défis et atteindre des objectifs ambitieux.", en: "I enjoy taking on challenges and achieving ambitious goals." },
  disc_3: { fr: "Je suis à l'aise pour parler devant un groupe.", en: "I am comfortable speaking in front of a group." },
  disc_4: { fr: "J'aime rencontrer de nouvelles personnes et créer des liens.", en: "I enjoy meeting new people and building connections." },
  disc_5: { fr: "Je préfère un environnement de travail stable et prévisible.", en: "I prefer a stable and predictable work environment." },
  disc_6: { fr: "Je suis patient et j'écoute attentivement les autres.", en: "I am patient and listen attentively to others." },
  disc_7: { fr: "Je suis méthodique et j'aime que les choses soient bien organisées.", en: "I am methodical and like things to be well organized." },
  disc_8: { fr: "Je vérifie les détails avant de prendre une décision.", en: "I check the details before making a decision." },
  disc_9: { fr: "Je préfère diriger plutôt que suivre.", en: "I prefer to lead rather than follow." },
  disc_10: { fr: "J'ai tendance à voir le côté positif des situations.", en: "I tend to see the positive side of situations." },
  val_1: { fr: "Le succès professionnel est une priorité importante pour moi.", en: "Professional success is an important priority for me." },
  val_2: { fr: "Je préfère travailler en équipe plutôt que seul.", en: "I prefer working in a team rather than alone." },
  val_3: { fr: "J'aime explorer de nouvelles idées et approches.", en: "I enjoy exploring new ideas and approaches." },
  val_4: { fr: "La sécurité et la stabilité sont importantes dans ma vie professionnelle.", en: "Security and stability are important in my professional life." },
  val_5: { fr: "J'apprécie avoir de l'autonomie dans mon travail.", en: "I appreciate having autonomy in my work." },
  val_6: { fr: "Aider les autres est une source de satisfaction pour moi.", en: "Helping others is a source of satisfaction for me." },
  val_7: { fr: "J'aime que mes contributions soient reconnues.", en: "I like my contributions to be recognized." },
  val_8: { fr: "J'ai soif d'apprendre et de me développer continuellement.", en: "I am eager to learn and develop continuously." },
  val_9: { fr: "Je suis orienté résultats et j'aime mesurer mes progrès.", en: "I am results-oriented and like to measure my progress." },
  val_10: { fr: "Construire des relations durables est essentiel pour moi.", en: "Building lasting relationships is essential for me." },
  val_11: { fr: "J'aime apporter des solutions créatives aux problèmes.", en: "I enjoy bringing creative solutions to problems." },
  val_12: { fr: "L'intégrité et l'honnêteté guident mes actions.", en: "Integrity and honesty guide my actions." }
};
